import React from 'react';
import FeatureCards from "../../components/FeatureCards/FeatureCards";
import CTA from "../../components/Constant/cta/CTA";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import WhySection from "../../components/WhySection/WhySection";
import LocationTimeline from "../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../components/IntroSection/IntroSection";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../components/ServiceCards/ServiceCards";

export default function UnitedArabEmiratesJurisdiction() {

    return (
        <main className='main'>
            <IntroSection
                title="United Arab Emirates (UAE) Jurisdiction"
                subtitle="Offshore Companies, Licensing & Residency in the UAE"
                description="The United Arab Emirates (UAE) is one of the world’s leading hubs for business, finance, and residency solutions. Known for its 0% corporate tax in Free Zones, strong infrastructure, and strategic location between Europe and Asia, the UAE attracts entrepreneurs, investors, and financial institutions from across the globe."
                badges={[
                    "Free Zone & Offshore Companies",
                    "Banking & FinTech",
                    "Residency & Golden Visa"
                ]}
                buttonText="Request a UAE Jurisdiction Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../assets/images/jurisdictions/uae-jurisdiction.png')}
                imageAlt="United Arab Emirates Offshore & Business Hub"
            />


            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose the UAE?'
                        blocks={[
                            {
                                items: [
                                    {
                                        title: "0% Corporate Tax",
                                        text: "In most Free Zones (until June 2023 corporate tax reform – still exemptions for many structures)."
                                    },
                                    {
                                        title: "100% Foreign Ownership",
                                        text: "Available in Free Zones."
                                    },
                                    {
                                        title: "Residency by Company Formation",
                                        text: "Investors and employees can obtain UAE residence visas."
                                    },
                                    {
                                        title: "No Currency Controls",
                                        text: "Free repatriation of profits."
                                    },
                                    {
                                        title: "Global Connectivity",
                                        text: "Banking, shipping, and logistics hub."
                                    },
                                    {
                                        title: "Reputation",
                                        text: "Respected globally, unlike some offshore-only jurisdictions."
                                    }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Company Formation in the UAE"
                        blocks={[
                            {
                                title: "Free Zone Companies",
                                items: [
                                    { text: "Most popular option for foreign investors." },
                                    { text: "Located in zones like DMCC, ADGM, DIFC, RAK Free Zone." },
                                    { text: "Benefits: 100% foreign ownership, 0% tax (in designated free zones), residency eligibility." }
                                ]
                            },
                            {
                                title: "Mainland Companies",
                                items: [
                                    { text: "Regulated by Department of Economic Development (DED)." },
                                    { text: "Required for businesses trading directly in UAE." },
                                    { text: "100% foreign ownership now allowed in many sectors." }
                                ]
                            },
                            {
                                title: "Offshore Companies",
                                items: [
                                    { text: "Examples: JAFZA Offshore, RAK Offshore." },
                                    { text: "Used for holding, asset protection, and international trade." },
                                    { text: "Not eligible for UAE residency." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Licenses Available in the UAE"
                        blocks={[
                            {
                                title: "🏦 Banking License",
                                items: [{ text: "Tightly regulated, issued by the Central Bank." }]
                            },
                            {
                                title: "💳 FinTech & EMI",
                                items: [{ text: "Available in ADGM and DIFC with strong recognition." }]
                            },
                            {
                                title: "🪙 Crypto & Digital Assets",
                                items: [{ text: "VARA Dubai and ADGM regulate exchanges, custodians, token projects." }]
                            },
                            {
                                title: "📈 Brokerage/Investment",
                                items: [{ text: "Regulated by SCA and ADGM." }]
                            },
                            {
                                title: "🛡️ Insurance & Reinsurance",
                                items: [{ text: "Regulated by UAE Central Bank." }]
                            },
                            {
                                title: "⚖️ Professional & Commercial Licenses",
                                items: [{ text: "Available in free zones and mainland." }]
                            }
                        ]}
                    />

                    <LocationTimeline
                        title="Residency & Golden Visa"
                        item={[
                            {
                                title: "Residency by Company Formation",
                                text: "Free Zone or Mainland company owners can apply for investor visas."
                            },
                            {
                                title: "Golden Visa Program",
                                text: "Long-term residence (5–10 years) for investors, property owners, and skilled professionals."
                            },
                            {
                                title: "Benefits",
                                text: "Tax residency, family sponsorship, access to UAE banking and healthcare."
                            }
                        ]}
                    />

                    <ServiceCards
                        title='Advantages of UAE Jurisdiction'
                        services={[
                            {
                                title: "🌍 Reputation",
                                text: "Trusted, not a 'tax haven.'"
                            },
                            {
                                title: "💼 Residency Pathways",
                                text: "Fast-track to UAE residency."
                            },
                            {
                                title: "🏦 Banking Access",
                                text: "UAE banks are globally recognized."
                            },
                            {
                                title: "⚡ Business Hub",
                                text: "Central to Middle East, Asia, Africa, and Europe."
                            },
                            {
                                title: "🚀 FinTech & Crypto Growth",
                                text: "UAE is positioning as a global blockchain and digital finance leader."
                            }
                        ]}
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <CTA
                        title="Ready to establish your UAE company or secure residency?"
                        description="Offshore Advisory helps clients incorporate in UAE Free Zones, obtain financial licenses, and secure UAE residency or Golden Visa."
                        buttonText="Book a UAE Consultation Today →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Can I open a company in Dubai without a local partner?",
        answer: "Yes, Free Zones and many Mainland sectors now allow 100% foreign ownership."
    },
    {
        question: "Do UAE offshore companies get residency visas?",
        answer: "No, only Free Zone and Mainland companies can issue visas."
    },
    {
        question: "What is the tax regime?",
        answer: "Free Zones = 0% tax (with exemptions). Mainland = 9% corporate tax above AED 375,000 net profits."
    },
    {
        question: "How long does it take to register a UAE company?",
        answer: "3–10 business days depending on Free Zone."
    },
    {
        question: "Is UAE good for crypto?",
        answer: "Yes, Dubai’s VARA and ADGM are leading crypto regulators worldwide."
    }
];
